<header class="main-header">
  <div class="header-left">
    <div class="logo-container py-2 d-flex align-items-center">
      <img class="logo" src="/images/logo_tim_enterprise.svg" alt="Logo Tim Enterprise" />
    </div>
  </div>

  <div class="header-right">

    @if (taskState(); as task) {
      <button
        class="task-indicator"
        [class.completed]="task.status === 'COMPLETED'"
        [class.failed]="task.status === 'FAILED'"
        (click)="handleTaskClick(task)"
        title="Clicca per dettagli"
      >
        <div class="indicator-icon">
          @if (task.status === 'COMPLETED') {
            <span class="material-symbols-outlined">check_circle</span>
          } @else if (task.status === 'FAILED') {
            <span class="material-symbols-outlined">error</span>
          } @else {
            <span class="material-symbols-outlined spin-icon">settings</span>
          }
        </div>

        <div class="indicator-info">
          <span class="label">
            @switch (task.status) {
              @case ('COMPLETED') { COMPLETATO }
              @case ('FAILED') { ERRORE }
              @default { IN CORSO... }
            }
          </span>
          <span class="value">{{ task.id | slice:0:8 }}...</span>
        </div>
      </button>
    }

    <div class="user-profile d-flex align-items-center gap-3">
      <div class="user-details text-end">
        <span class="user-name fw-bold d-block">{{ user()?.firstName }} {{ user()?.lastName }}</span>
        <span class="user-role text-muted small">{{ user()?.email }}</span>
      </div>

      <div class="avatar-wrapper">
        <div class="avatar-initials bg-primary text-white rounded-circle d-flex align-items-center justify-content-center">
          {{ getInitials(user()?.firstName, user()?.lastName) }}
        </div>
      </div>

      <button class="btn btn-outline-danger btn-sm ms-2 logout-btn" (click)="logout()" title="Esci">
        <span class="material-symbols-outlined align-middle">logout</span>
      </button>
    </div>

  </div>
</header>

@if (isModalOpen()) {
  <div class="modal-backdrop"
       tabindex="-1"
       aria-hidden="true"
       (click)="closeModal()"
       (keydown.enter)="closeModal()">

    <div class="modal-dialog modal-lg"
         (click)="$event.stopPropagation()"
         (keydown)="$event.stopPropagation()">

      <div class="modal-header flex-column align-items-stretch gap-2">
        <div class="d-flex justify-content-between align-items-center w-100">

          <div class="modal-title d-flex align-items-center gap-2">
            <span class="material-symbols-outlined"
                  [class.text-danger]="taskState()?.status === 'FAILED'"
                  [class.text-success]="taskState()?.status === 'COMPLETED'"
                  [class.text-primary]="taskState()?.status === 'IN_PROGRESS' || taskState()?.status === 'PENDING'"
                  [class.spin-icon]="taskState()?.status === 'IN_PROGRESS' || taskState()?.status === 'PENDING'">
              @switch (taskState()?.status) {
                @case ('COMPLETED') { task_alt }
                @case ('FAILED') { error }
                @default { settings }
              }
            </span>
            <h3 class="m-0 fs-5">Dettaglio Task: {{ taskState()?.id }}</h3>
          </div>

          <button class="close-btn btn btn-sm btn-light" (click)="closeModal()">
            <span class="material-symbols-outlined align-middle">close</span>
          </button>
        </div>

        <div class="d-flex gap-4 text-muted mt-1 modal-dates">
          <span><strong>Avviato:</strong> {{ taskState()?.createdAt | date:'dd/MM/yyyy - HH:mm:ss' }}</span>
          <span><strong>Aggiornato:</strong> {{ taskState()?.updatedAt | date:'dd/MM/yyyy - HH:mm:ss' }}</span>
        </div>
      </div>

      <div class="modal-body p-0">

        @if (taskState()?.status === 'IN_PROGRESS' || taskState()?.status === 'PENDING') {
          <div class="bg-white px-4 py-3 border-bottom">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="fw-bold text-primary">Scansione in corso...</span>
              <span class="fw-bold text-muted">
                {{ taskState()?.results?.length || 0 }}

                @if (taskState()?.metadata?.totalFiles) {
                  / {{ taskState()?.metadata?.totalFiles }}
                }

                {{ taskState()?.metadata?.totalFiles ? 'file' : 'elementi' }}
              </span>
            </div>
            <div class="progress progress-bar-wrapper">
              <progress class="progress-bar progress-bar-striped progress-bar-animated bg-primary"
                  [style.width.%]="taskState()?.metadata?.totalFiles ? ((taskState()?.results?.length || 0) / (taskState()?.metadata?.totalFiles || 1)) * 100 : 100">
              </progress>
            </div>
          </div>
        }

        <div class="p-3 bg-light d-flex justify-content-around border-bottom">
           <div class="text-center">
             <small class="text-muted d-block">Totali</small>
             <span class="fw-bold fs-5">{{ taskState()?.metadata?.totalFiles || taskState()?.results?.length || 0 }}</span>
           </div>
           <div class="text-center">
             <small class="text-success d-block">Successo</small>
             <span class="fw-bold fs-5 text-success">{{ getCountByStatus('SUCCESS') }}</span>
           </div>
           <div class="text-center">
             <small class="text-danger d-block">Errori</small>
             <span class="fw-bold fs-5 text-danger">{{ getCountByStatus('ERROR') }}</span>
           </div>
        </div>

        <div class="list-group list-group-flush selectable-text-list">
          @for (result of taskState()?.results; track $index) {
            <div class="list-group-item d-flex justify-content-between align-items-start p-3 border-bottom">

              <div class="ms-2 me-auto overflow-hidden w-100">
                <div class="d-flex align-items-center gap-2">
                  <div class="fw-bold text-truncate file-name-truncate" [title]="result.fileName || result.url">
                    {{ result.fileName || result.url }}
                  </div>

                  @if (result.syncStatus) {
                    @switch (result.syncStatus) {
                      @case ('UPDATED') {
                        <span class="badge bg-primary text-white sync-badge">Aggiornata</span>
                      }
                      @case ('ADDED') {
                        <span class="badge bg-success text-white sync-badge">Nuova</span>
                      }
                      @case ('UNCHANGED') {
                        <span class="badge bg-secondary text-white sync-badge">Invariata</span>
                      }
                      @case ('DELETED') {
                        <span class="badge bg-danger text-white sync-badge">Rimossa</span>
                      }
                    }
                  }
                </div>

                <small class="text-muted d-block mt-1">
                  {{ result.status === 'SUCCESS' ? 'Pipeline completata' : (result.error || 'Errore generico') }}
                </small>
              </div>

              <span class="badge rounded-pill ms-3 mt-1 flex-shrink-0"
                    [class.bg-success]="result.status === 'SUCCESS'"
                    [class.bg-danger]="result.status === 'ERROR'">
                {{ result.status }}
              </span>
            </div>
          }
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn-outline-secondary" (click)="closeModal()">Chiudi</button>

        @if (taskState()?.status === 'COMPLETED' || taskState()?.status === 'FAILED') {
          <button type="button" class="btn-danger" (click)="confirmDismissTask()">
            Rimuovi Notifica
          </button>
        }
      </div>

    </div>
  </div>
}
